import axios from 'axios';
import { interceptorOnResponse, interceptorOnResponseError } from '~/utils/axios-token-interceptor.js';

export default defineNuxtPlugin(async () => {
  const auth = useAuth();
  const config = useRuntimeConfig();
  // TODO: properly configure axios
  const instance = axios.create({
    baseURL: config.public.apiV1BaseUrl,
    headers: {
      Authorization: `Bearer ${auth.idToken.value}`,
    },
  });
  instance.interceptors.response.use(interceptorOnResponse(), interceptorOnResponseError(instance));
  // TODO: handle this errors
  // instance.onError((error) => {
  //   const code = parseInt(error.response && error.response.status);
  //   if (code === 422) {
  //     const err_detail =
  //       (error.response.data &&
  //         error.response.data.errors &&
  //         error.response.data.errors.length &&
  //         error.response.data.errors[0].detail) ||
  //       'Unknown error detected. Please get in touch with our support team.';
  //     throw new Error(err_detail);
  //   }
  // });

  return {
    provide: {
      axios: instance
    }
  }
});
